// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BD-z","smallCardRow":"CD-z","largeCardRow":"DD-z","productSearchRow":"ED-z","curatedRow":"FD-z"};